import type global from "global";

export type OcrLogLike =
	| Pick<global.ocr, "status" | "is_approved">
	| null
	| undefined;

export type OcrStatusColor = "green" | "red" | "grey";

export type OcrStatusTextVariant = "default" | "compact";

const PROCESSING_TEXT: Record<OcrStatusTextVariant, string> = {
	default: "Обрабатывается",
	compact: "-",
};

export function getOcrStatusText(
	ocrLog: OcrLogLike,
	variant: OcrStatusTextVariant = "default",
): string {
	if (!ocrLog) return "Неизвестно";
	if (ocrLog.status === "processing" || ocrLog.status === "pending")
		return PROCESSING_TEXT[variant];
	return ocrLog.is_approved ? "Пройден" : "Не пройден";
}

export function getOcrStatusColor(ocrLog: OcrLogLike): OcrStatusColor {
	if (!ocrLog || ocrLog.status === "processing" || ocrLog.status === "pending")
		return "grey";
	return ocrLog.is_approved ? "green" : "red";
}

export function isOcrProcessing(ocrLog: OcrLogLike): boolean {
	return ocrLog?.status === "processing" || ocrLog?.status === "pending";
}

export function getOcrStatusClassName(
	ocrLog: OcrLogLike,
	styles: Partial<Record<OcrStatusColor, string>>,
): string | undefined {
	const color = getOcrStatusColor(ocrLog);
	return styles[color];
}
